export default "__VITE_ASSET__155207ae__"